import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { isSessionValid, logout } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const decodeTokenClaims = (jwtToken) => {
    try {
      const payload = jwtToken?.split('.')?.[1];
      if (!payload) return {};
      const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
      const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
      return JSON.parse(atob(padded));
    } catch {
      return {};
    }
  };

  useEffect(() => {
    // Check session validity on mount and set up periodic checks
    if (!isSessionValid()) {
      logout();
      return;
    }

    // Check every minute if session is still valid
    const interval = setInterval(() => {
      if (!isSessionValid()) {
        logout();
      }
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const token = localStorage.getItem("accessToken") || localStorage.getItem("authToken");
  const otpVerified = localStorage.getItem("otpVerified") === "true";
  const sessionValid = isSessionValid();
  const claims = decodeTokenClaims(token);
  const cardStatus = (claims?.cardStatus || "").toString().toUpperCase();
  const isClosedCardUser = cardStatus === "C" || cardStatus === "Q";

  if (!token || !sessionValid) {
    return <Navigate to="/" replace />;
  }

  if (!otpVerified) {
    return <Navigate to="/otp" replace />;
  }

  if (isClosedCardUser && location.pathname !== "/noc") {
    return <Navigate to="/noc" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;